import $ from 'jquery';

export default function video() {
  
  function modalVideoYT() {
    $('#videoModalBtn').on('click', function() {
      player.playVideo();
    });
    
    $('#closeModalBtn').on('click', function() {
      player.pauseVideo();
    });
  }
  
  $( document ).ready(function() {
    if($('.youtube-container').length > 0) {
      modalVideoYT();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/video.js